import { BaseDto } from '../base.dto';
import { IsDefined, IsInt, IsString, Length, Matches } from 'class-validator';
import { validationPatterns } from '../../constants';

export class BankingHouseAccountApprovalDto extends BaseDto {
  @IsDefined()
  @IsInt()
  orderPaymentId: number;

  @IsDefined()
  @IsInt()
  houseAccountId: number;

  @IsDefined()
  @IsInt()
  approvedEmployeeId: number;

  @IsDefined()
  @IsString()
  @Length(0, 255)
  @Matches(validationPatterns.noteValidation)
  description:string;
}
